<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 650 : 'auto'"
    style="z-index: 1200 !important;"
  >
    <v-card v-cloak>
      <v-card-title class="d-flex justify-space-between">
        <span>{{ $t('console.connectedTenantsHelp.dialogTitle') }}</span>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text scrollable class="scrollable mt-4">
        <i18n-t
          keypath="console.connectedTenantsHelp.homeListDialog.p1"
          tag="p"
        >
          <template #nameColumn>
            <span class="font-weight-bold">
              {{ $t('console.name') }}
            </span>
          </template>
          <template #usersColumn>
            <span class="font-weight-bold">
              {{ $t('console.users') }}
            </span>
          </template>
          <template #foldersColumn>
            <span class="font-weight-bold">
              {{ $t('console.folders') }}
            </span>
          </template>
          <template #tenantNotConnectedYet>
            <span class="font-weight-bold font-italic">
              {{ $t('console.tenantNotConnected') }}
            </span>
          </template>
        </i18n-t>
        <i18n-t
          keypath="console.connectedTenantsHelp.homeListDialog.p2"
          tag="p"
        >
          <template #threeDotsIcon>
            <v-icon icon="mdi-dots-vertical" />
          </template>
          <template #requestConnection>
            <span class="font-weight-bold">
              {{ $t('console.requestConnection') }}
            </span>
          </template>
        </i18n-t>
        <h3>
          {{ $t('console.connectedTenantsHelp.homeListDialog.connectionActions.managePermissions.subtitle') }}
        </h3>
        <i18n-t
          keypath="console.connectedTenantsHelp.homeListDialog.connectionActions.managePermissions.p1"
          tag="p"
        >
          <template #selectFolderToShare>
            <span class="font-weight-bold">
              {{ $t('console.thisFoldersWillBeShared') }}
            </span>
          </template>
          <template #save>
            <span class="font-weight-bold">
              {{ $t('common.save') }}
            </span>
          </template>
          <template #connectionCode>
            <span class="font-weight-bold">
              {{ $t('console.connectioncode') }}
            </span>
          </template>
        </i18n-t>
        <v-alert type="warning" variant="outlined">
          <i18n-t
            keypath="console.connectedTenantsHelp.homeListDialog.connectionActions.managePermissions.userManagementWarning"
            tag="div"
          >
            <template #userManagementPermission>
              <span class="font-weight-bold">
                {{ $t('console.managePermissions') }}
              </span>
            </template>
            <template #not>
              <span class="font-weight-bold font-upper-case">
                {{ $t('common.not') }}
              </span>
            </template>
            <template #teamOnly>
              <span class="font-weight-bold">
                {{ $t('common.teamonly') }}
              </span>
            </template>
          </i18n-t>
        </v-alert>
        <h3>
          {{ $t('console.connectedTenantsHelp.homeListDialog.connectionActions.disconnect.subtitle') }}
        </h3>
        <i18n-t
          keypath="console.connectedTenantsHelp.homeListDialog.connectionActions.disconnect.text"
          tag="p"
        >
          <template #removeConnection>
            <span class="font-weight-bold">
              {{ $t('console.removeConnection') }}
            </span>
          </template>
        </i18n-t>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  name: 'HomeTenantListHelpDialog',
  mixins: [ DialogActionKeys, DialogModel ],
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0.75rem;

  &:not(:first-child) {
    margin-top: 0.75rem;
  }
}

h3 {
  margin-top: 0.75rem;
}

.font-upper-case {
  text-transform: uppercase;
}
</style>
